var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2375 9.5L7.5 3.93725L1.7625 9.5L1.49716e-07 7.78745L7.5 0.499999L15 7.78745L13.2375 9.5Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpIcon);
export default __webpack_public_path__ + "static/media/sortUpIcon.aa98cd1ee05826cc659ffcb84eef53ce.svg";
export { ForwardRef as ReactComponent };